export const widgetFieldProps = {
  modelValue: {
    type: String,
    required: true,
  },
  readonly: {
    type: Boolean,
  },
  hasError: {
    type: Boolean,
  },
  errorMessage: {
    type: String,
  },
}

export type WidgetFieldProps<T> = {
  modelValue: T
  readonly?: boolean
  hasError?: boolean
  errorMessage?: string
}

export const widgetFieldEvents = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'update:model-value': (value: string) => true,
  focus: () => true,
  blur: () => true,
}

export type WidgetFieldEmits<T> = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'update:model-value': [T]
  focus: []
  blur: []
}

export const widgetFormFieldProps = {
  name: {
    type: String,
    required: true,
  },
}

export type WidgetFormFieldProps = {
  name: string
  modelValueOverride?: boolean
}
